export default "__VITE_ASSET__fed054c1__"